import {
  Add_StageType,
  Delete_StageType,
  Get_All_StageType,
  Get_Error,
  Get_One_StageType,
  Update_One_StageType,
} from '../Types';

const intial = {
  stagetype: [],
  Updatestagetype: [],
  loading: true,
};

const StageType_Reducer = (state = intial, action) => {
  switch (action.type) {
    case Add_StageType:
      return {
        ...state,
        stagetype: action.payload,
        loading: false,
      };
    case Get_All_StageType:
      return {
        ...state,
        stagetype: action.payload,
        loading: false,
      };

    case Delete_StageType:
      return {
        ...state,
        stagetype: action.payload,
        loading: false,
      };

    case Get_One_StageType:
      return {
        ...state,
        stagetype: action.payload,
        loading: false,
      };

    case Update_One_StageType:
      return {
        ...state,
        Updatestagetype: action.payload,
        loading: false,
      };

    case Get_Error:
      return {
        loading: true,
        stagetype: action.payload,
      };
    default:
      return state;
  }
};

export default StageType_Reducer;
